const days = [
    'Sunnuntaina',
    'Maanantaina',
    'Tiistaina',
    'Keskiviikkona',
    'Torstaina',
    'Perjantaina',
    'Lauantaina',
];

/**
 * Get the post time left formatted.
 */
export default function (postId, endsAt, fromNow) {
    return {
        postId: postId,
        timestamp: parseInt(endsAt),
        timer: null,
        fromNow: fromNow,
        getTime: function () {
            return this.fromNow ? this.getTimeLeft() : this.getTimeUserLocale();
        },
        getTimeUTC: function () {
            return new Date(this.timestamp).toISOString();
        },
        getTimeLeft: function () {
            return this.timeLeft || '...';
        },
        getTimeUserLocale: function () {
            let date = new Date(this.timestamp);
            return (
                days[date.getDay()] +
                ' ' +
                date.getDate() +
                '.' +
                (date.getMonth() + 1) +
                '.' +
                date.getFullYear() +
                ' ' +
                (date.getHours() + '').padStart(2, '0') +
                ':' +
                (date.getMinutes() + '').padStart(2, '0')
            );
        },
        mounted: function () {
            const self = this;

            /**
             * Format the post time.
             */
            function formatTime() {
                let seconds = self.timestamp - Date.now();

                if (seconds <= 0) {
                    self.timeLeft = 'Päättynyt';
                    clearInterval(self.timer);

                    return;
                }

                seconds = seconds / 1000;

                const formats = [
                    {
                        amount: Math.floor(seconds / (3600 * 24)),
                        unit: 'pv',
                    },
                    {
                        amount: Math.floor((seconds % (3600 * 24)) / 3600),
                        unit: 'h',
                    },
                    {
                        amount: Math.floor((seconds % 3600) / 60),
                        unit: 'min',
                    },
                    {
                        amount: Math.floor(seconds % 60),
                        unit: 's',
                    },
                ];

                for (let index = 0; index < formats.length; index++) {
                    const format = formats[index];
                    const secondFormat = formats[index + 1];

                    if (format.amount > 0) {
                        self.timeLeft =
                            format.amount +
                            ' ' +
                            format.unit +
                            (secondFormat && secondFormat.amount > 0
                                ? ' ' + secondFormat.amount + ' ' + secondFormat.unit
                                : '');
                        return;
                    }
                }
            }

            /**
             * Extend the post time.
             *
             * @param {Object} data
             */
            function extendTime(data) {
                if (data.id != self.postId) {
                    return;
                }

                self.timestamp = parseInt(data.ends_at_extended);
            }

            formatTime();
            this.timer = setInterval(() => formatTime(), 1000);

            const channel = window.Echo.connector.channels['posts'];

            if (channel) {
                channel.listen('Posts.PostUpdated', (data) => extendTime(data));

                return;
            }

            window.Echo.channel('posts').listen('Posts.PostUpdated', (data) => extendTime(data));
        },
    };
}
